import { toast } from "sonner";
import { api } from "./api";

export const UNDO_MS = 8000;

// The only way the client blocks someone. Shows an 8s toast with Undo (→ DELETE /users/:id/block).
export async function blockMember(ref, { name, onBlocked, onUndone } = {}) {
  await api.post(`/users/${ref}/block`);
  onBlocked?.();
  toast.success(name ? `Blocked ${name}.` : "Blocked.", {
    id: `block-${ref}`,
    duration: UNDO_MS,
    description: "You won't see each other anymore.",
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.delete(`/users/${ref}/block`);
          toast.success(name ? `Unblocked ${name}.` : "Unblocked.", { id: `unblock-${ref}` });
          onUndone?.();
          window.dispatchEvent(new Event("members:reload"));
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Could not undo. Use Settings → Privacy → Blocked members.");
        }
      },
    },
  });
}
